import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PURPLE, COLOR_PURPLE_HOVER } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  boxFeatures: {
    background: '#fff',
    padding: theme.spacing(6.75, 0, 9, 0),
    textAlign: 'center',
  },
  button: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: 700,
    borderRadius: 40,
    backgroundColor: COLOR_PURPLE,
    color: '#fff',
    fontSize: 18,
    border: 'none',
    boxShadow: 'none',
    fontFamily: 'Lato',
    '&:hover': {
      backgroundColor: COLOR_PURPLE_HOVER,
    },
  },
  tagPage: {
    color: COLOR_GRAY_70,
    fontSize: 18,
    fontWeight: 700,
    textAlign: 'center',
    display: 'block',
    fontFamily: 'Lato',
  },
  titleHero: {
    fontFamily: 'Lato',
    fontSize: 30,
    textAlign: 'center',
    color: COLOR_GRAY_70,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    lineHeight: 'inherit',
    '& b': {
      color: COLOR_PURPLE,
    },
  },
  subtitle: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 20,
    textAlign: 'center',
    margin: '0 auto',
    marginBottom: theme.spacing(6.75),
  },
  boxButton: {
    '& button': {
      boxShadow: 'none',
      fontSize: 18,
      fontWeight: 400,
      fontFamily: 'Lato',
    },
  },
}));
